import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import AvailableLists from './AvailableLists';

function RenderAvailableLists({ fields, selectableFields }) {
  return (
    <>
      <Label>
        <FormattedMessage
          id="ui-plugin-inventory-templates.driveNewFieldsModal.availableLists.label"
          defaultMessage="Available lists"
        />
      </Label>
      {fields?.map((field, index) => {
        return (
          <AvailableLists
            key={`${field.name}-${index}`}
            fieldData={selectableFields[index]}
            fieldName={field}
            index={index}
            fields={fields}
          />
        );
      })}
    </>
  );
}

RenderAvailableLists.propTypes = {
  fields: PropTypes.object,
  selectableFields: PropTypes.arrayOf(PropTypes.object),
};

export default RenderAvailableLists;
